import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import Empty from 'constants/empty';
import helperUtils from 'utils/Helpers';
import { COMPARE_MODAL } from 'components/Catalog/ProductGrid/CompareModal/constants';

const { getProp } = helperUtils;
const { PAGE_NAMES } = anaConsts;

const SEPHORA_PAGE_NAME_PATH = 'page.attributes.sephoraPageInfo.pageName';

class storeSelectorModalBindings {
    static getPreviousPageName() {
        try {
            return getProp(digitalData, SEPHORA_PAGE_NAME_PATH) || Empty.String;
        } catch (error) {
            Sephora.logger.error('Failed to get previous page name:', error);

            return Empty.String;
        }
    }

    static storeSwitcherLoad = (entry, { componentName } = {}) => {
        const previousPageName =
            componentName === COMPARE_MODAL ? PAGE_NAMES.COMPARE_PRODUCT_MODAL : storeSelectorModalBindings.getPreviousPageName();

        const eventData = {
            pageName: 'buy online and pickup:store selection:n/a:*',
            previousPageName,
            ...(entry && { linkData: `${entry} entry` })
        };

        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, { data: eventData });
    };
    static triggerAnalytics = (stockStatus = null, storeId = '', skuId = '') => {
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                actionInfo: `${anaConsts.ACTION_INFO.SEPHORA_KOHLS_EXIT_LINK}:${stockStatus}`,
                storeId,
                ...(skuId.length && {
                    productStrings: `;${skuId};;;;eVar26=${skuId}`
                })
            }
        });
    };
}

export default storeSelectorModalBindings;
